// extracted by mini-css-extract-plugin
export default {"taxonomy-search-input":"lsf-taxonomy-search-input"};